import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGetClientStatementData } from '../api/types/leadership';

interface ILeadershipCapabilitySLModalProps {
  isOpen: boolean;
  modalType: 'add' | 'edit';
  initialValues: {
    id: string;
    name: string;
    description: string;
    accelerator: string;
  };
}

const initialState: ILeadershipCapabilitySLModalProps = {
  isOpen: false,
  modalType: 'add',
  initialValues: {
    id: '',
    name: '',
    description: '',
    accelerator: '',
  },
};

const leadershipCapabilitySLModalSlice = createSlice({
  name: 'leadershipCapabilitySLModal',
  initialState,
  reducers: {
    closeLeadershipCapabilitySLModal: (state) => {
      state.isOpen = false;
      state.initialValues = initialState.initialValues;
    },
    openAddLeadershipCapabilitySLModal: () => ({
      ...initialState,
      isOpen: true,
    }),
    openEditLeadershipCapabilitySLModal: (
      state,
      action: PayloadAction<IGetClientStatementData>
    ) => {
      state.isOpen = true;
      state.modalType = 'edit';
      state.initialValues = {
        id: action.payload.id || '',
        name: action.payload.name || '',
        description: action.payload.description || '',
        accelerator:
          action.payload.acceleratorCode || action.payload.accelerator || '',
      };
    },
  },
});

export const leadershipCapabilitySLModalActions =
  leadershipCapabilitySLModalSlice.actions;
export const leadershipCapabilitySLModalReducer =
  leadershipCapabilitySLModalSlice.reducer;
